let trueFalseToYesNo = (value) => { return value == true || value == 1 ? 'YES' : 'NO' }

let trueFalseNotSetToYesNoNa = (value) => {
    if (typeof value === 'undefined' || value === null || value.length <= 0) {
        return 'NA'
    } else {
        return value == true || value == 1 ? 'YES' : 'NO'
    }
}

let trueFalseNotSetToYesNoUnavailable = (value) => {
    if (typeof value === 'undefined' || value === null || value.length <= 0) {
        return null //'NOT PROVIDED'
    } else {
        return value == true || value == 1 ? 'YES' : 'NO'
    }
}

const stringNotNullOrEmptyYesNo = (value) => {
    if (typeof value === 'undefined' || value === null || value.length <= 0) {
        return 'NO'
    } else {
        return 'YES'
    }
}

const formatNumber = (dec) => (val) => {
    if (!isNaN(parseFloat(val))) {
        return val.toFixed(dec)
    } else {
        return 0
    }
}

export { trueFalseToYesNo, formatNumber, stringNotNullOrEmptyYesNo, trueFalseNotSetToYesNoNa, trueFalseNotSetToYesNoUnavailable }